import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {spacing} from '@/theme/theme.ts'
import {Button} from '@components/ui/button/Button.tsx'

export const StyledCreateUserModalContent = styled.div`
    ${({theme: {typography, palette}}) => css`
        & h4 {
            ${typography.textXl};
            font-weight: 500;
            color: ${palette.neutral['900']};
        }
        & p {
            ${typography.textMd};
            color: ${palette.neutral['900']};
        }
    `}
`
export const StyledCreateUserModalHeader = styled(Flexbox)`
    ${({theme: {palette}}) => css`
        padding: ${spacing * 4}px ${spacing * 6}px;
        border-bottom: 1px solid ${palette.neutral['300']};
    `}
`

export const StyledCreateUserModalCloseButton = styled(Button)`
    ${() => css`
        position: absolute;
        left: 8px;
        top: 10px;
    `}
`
